// Tooltip único da aplicação: elementos com data-tip="item:<id>" (ou outro
// provedor registrado) mostram um balão. Mouse: ao passar por cima.
// Toque: segurar ~0,35s (o toque curto continua sendo um clique normal).
import { esc } from "./ui";
import { itemTooltip, traitTooltip, unitTooltip } from "./data";
import { spriteHtml } from "./sprites";

type Provider = (arg: string) => string;
const providers: Record<string, Provider> = {
  item: (id) => itemTooltip(id, esc),
  unit: (arg) => {
    const [id, owned] = arg.split(":");
    return unitTooltip(id!, esc, (sp) => spriteHtml(sp, 40), Number(owned) || 0);
  },
  trait: (arg) => {
    const [key, count] = arg.split(":");
    return traitTooltip(key!, Number(count) || 0, esc);
  },
};

let tip: HTMLElement | null = null;
let current: Element | null = null;
let pressTimer = 0;
/** depois de um toque longo, ignora o clique que vem em seguida */
let swallowClick = false;

function el(): HTMLElement {
  if (!tip) {
    tip = document.createElement("div");
    tip.className = "tip bw-panel";
    tip.setAttribute("role", "tooltip");
    tip.hidden = true;
    document.body.appendChild(tip);
  }
  return tip;
}

function render(spec: string): string | null {
  const i = spec.indexOf(":");
  const p = providers[spec.slice(0, i)];
  return p ? p(spec.slice(i + 1)) : null;
}

/** Mostra o tooltip perto de um ponto (usado também pelo tabuleiro PixiJS). */
export function showTipAt(spec: string, x: number, y: number) {
  const html = render(spec);
  if (!html) return;
  const t = el();
  t.innerHTML = html;
  t.hidden = false;
  const r = t.getBoundingClientRect();
  const vw = window.innerWidth, vh = window.innerHeight;
  let left = x - r.width / 2;
  let top = y - r.height - 12;
  if (top < 8) top = Math.min(vh - r.height - 8, y + 16);
  left = Math.max(8, Math.min(vw - r.width - 8, left));
  t.style.left = `${left}px`;
  t.style.top = `${Math.max(8, top)}px`;
}

function showFor(target: Element) {
  current = target;
  const r = target.getBoundingClientRect();
  showTipAt((target as HTMLElement).dataset.tip!, r.left + r.width / 2, r.top);
}

export function hideTip() {
  current = null;
  if (tip) tip.hidden = true;
}

export function installTooltips() {
  document.addEventListener("pointerover", (e) => {
    if (e.pointerType !== "mouse") return;
    const t = (e.target as Element).closest?.("[data-tip]");
    if (t && t !== current) showFor(t);
    else if (!t && current) hideTip();
  });
  document.addEventListener("pointerdown", (e) => {
    clearTimeout(pressTimer);
    if (e.pointerType === "mouse") return;
    const t = (e.target as Element).closest?.("[data-tip]");
    if (!t) return hideTip();
    pressTimer = window.setTimeout(() => {
      showFor(t);
      swallowClick = true;
    }, 350);
  });
  const cancel = () => clearTimeout(pressTimer);
  document.addEventListener("pointerup", cancel);
  document.addEventListener("pointercancel", cancel);
  document.addEventListener("click", (e) => {
    if (swallowClick) {
      swallowClick = false;
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  document.addEventListener("contextmenu", (e) => {
    if ((e.target as Element).closest?.("[data-tip]")) e.preventDefault();
  });
  window.addEventListener("scroll", hideTip, true);
  window.addEventListener("hashchange", hideTip);
}
